import { render, staticRenderFns } from "./TableDataSevenbank.vue?vue&type=template&id=2a213a12&"
import script from "./TableDataSevenbank.vue?vue&type=script&lang=ts&"
export * from "./TableDataSevenbank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports